import Collapsible from 'react-collapsible';
import { PropTypes as RPT } from 'prop-types';

import React from 'react';
import { Element } from 'react-scroll';


const Accordion = ({
  data,
  openedQuestions,
  linkPrefix,
  handleQuestionClick,
}) => (
  <div className="Accordion">
    {data.map((item, index) => {
      const link = `${linkPrefix}${index}`;
      const isOpen = openedQuestions.indexOf(link) !== -1;

      return (
        <Element name={link} key={item.get('label')} onClick={handleQuestionClick(link, true)}>
          <Collapsible open={isOpen} trigger={item.get('label')}>
            <div>{item.get('hint')}</div>
          </Collapsible>
        </Element>
      );
    })}
  </div>
);

Accordion.propTypes = {
  data: RPT.object,
  handleQuestionClick: RPT.func.isRequired,
  linkPrefix: RPT.string.isRequired,
  openedQuestions: RPT.array,
};

export default Accordion;
